import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './i18n.js'

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    console.error('[Window Uncaught Error]:', event.message, event.filename, event.lineno, event.error?.stack);
  });
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Window Unhandled Rejection]:', event.reason?.message || event.reason, event.reason?.stack);
  });

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        reg.update();
      }
    });
  }
}

// Simple Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary Caught]:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '30px', 
          maxWidth: '800px',
          margin: '40px auto',
          textAlign: 'center', 
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#1f2937',
          backgroundColor: '#fff',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#dc2626' }}>Application Error Encountered</h2>
          <p style={{ color: '#b91c1c', margin: '12px 0', fontWeight: '600' }}>
            {this.state.error?.message || String(this.state.error) || 'Unknown error occurred'}
          </p>
          {this.state.error?.stack && (
            <pre style={{ 
              textAlign: 'left', 
              background: '#f3f4f6', 
              padding: '12px', 
              borderRadius: '8px', 
              overflowX: 'auto', 
              fontSize: '11px',
              maxHeight: '200px'
            }}>
              {this.state.error.stack}
            </pre>
          )}
          {this.state.errorInfo?.componentStack && (
            <pre style={{ 
              textAlign: 'left', 
              background: '#fef2f2', 
              padding: '12px', 
              borderRadius: '8px', 
              overflowX: 'auto', 
              fontSize: '11px',
              marginTop: '10px',
              maxHeight: '200px'
            }}>
              Component Stack:{this.state.errorInfo.componentStack}
            </pre>
          )}
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              style={{
                padding: '10px 24px',
                backgroundColor: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)